import { CustomButton } from "Components/CustomButton";
import { ModalComponentV1 } from "Components/ModalComponentV1";
import { TransactionAction } from "helpers/backend_helper";
import InfoBold from "assets/svg/InfoBoldNotShape.svg";
import styles from "./index.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onAction: () => Promise<void>;
  isActionLoading: boolean;
  type: TransactionAction;
};

const infoActions = {
  unhold: {
    title: "Unhold Deposit",
    value: "Do you really want to unhold the deposit?",
    actionText: "Unhold",
  },
  retry: {
    title: "Retry Transaction",
    value: "Do you really want to retry the transaction?",
    actionText: "Retry",
  },
  recreate_payment: {
    title: "Retry Transaction",
    value: "Do you really want to retry the transaction?",
    actionText: "Retry",
  },
  complete: {
    title: "Complete Transaction",
    value: "Do you really want to complete the transaction?",
    actionText: "Complete",
  },
  cancel: {
    title: "Cancel Transaction",
    value: "Do you really want to cancel the transaction?",
    actionText: "Cancel Transaction",
  },
};

export const ModalConfirm = ({ isActionLoading, isOpen, onAction, onClose, type }: Props) => {
  const onConfirm = async () => {
    await onAction();
  };
  return (
    <ModalComponentV1 isOpen={isOpen} onClose={onClose} title={infoActions[type]?.title ?? "Confirm Action"}>
      <div className={styles.wrapper}>
        <div>{infoActions[type]?.value ?? "Do you really want to continue?"}</div>
        {type === "complete" && (
          <div className={styles.infoWrapper}>
            <img src={InfoBold} alt="info icon" />{" "}
            <div>Please make sure that the recipient has recieved the payment</div>
          </div>
        )}
        <div className={styles.antWrapper}>
          <CustomButton sizeButton="large" typeButton="tertiary" onClick={onClose}>
            Cancel
          </CustomButton>
          <CustomButton
            sizeButton="large"
            typeButton={type === TransactionAction.COMPLETE ? "critical" : "primary"}
            onClick={onConfirm}
            loading={isActionLoading}
          >
            {infoActions[type]?.actionText ?? "Confirm"}
          </CustomButton>
        </div>
      </div>
    </ModalComponentV1>
  );
};
